/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage} from 'react-intl';
import {Alert} from 'eui-components';

export const ForbiddenView = (props) => {
  return (
    <div>
      <Alert bsStyle='danger'>
        <h4><FormattedMessage id='ForbiddenView.header' defaultMessage='Permission denied' /></h4>
        <p>
          <FormattedMessage id='ForbiddenView.message'
            defaultMessage={'You do not have permission to retrieve the URL or link you requested.'} />
        </p>

        { props.path && <p style={{padding: '10px 25px', fontStyle: 'italic'}}>{props.path}</p>}

        <p>
          <FormattedMessage id='ForbiddenView.whatsNext'
            defaultMessage='Inform the administrator of the referring page if you think this is a mistake.'/>
        </p>
      </Alert>
    </div>
  );
};

ForbiddenView.propTypes = {
  path: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/ForbiddenView/ForbiddenView.js